const languages = [ 'Afar', 'Achinese', 'Afrikaans', 'Amharic', 'Arabic', 'Assamese', 'Azerbaijani', 'Bambara', 'Bengali', 'Berber', 'Bosnian', 'Bulgarian', 'Catalan', 'Czech', 'Dagbani', 'Danish', 'German', 'Divehi', 'English', 'Esperanto', 'Persian', 'Filipino', 'Finnish', 'French', 'Gujarati', 'Hausa', 'Hebrew', 'Hindi', 'Croatian', 'Hungarian', 'Iranun', 'Indonesian', 'Italian', 'Javanese', 'Japanese', 'Kannada', 'Kazakh', 'Khmer', 'Kinyarwanda', 'Kirghiz', 'Kurmanji', 'Kendayan', 'Korean', 'Kurdish', 'Latin', 'Ganda', 'Luyia', 'Malayalam', 'Marathi', 'Macedonian', 'Maltese', 'Maranao', 'Malay', 'Burmese', 'Nepali', 'Dutch', 'Norwegian', 'Chichewa', 'Oromo', 'Panjabi', 'Polish', 'Portuguese', 'Pushto', 'Romanian', 'Rundi', 'Russian', 'Sinhala', 'Slovak', 'Shona', 'Sindhi', 'Somali', 'Sotho', 'Spanish', 'Albanian', 'Swahili', 'Swedish', 'Tamil', 'Tatar', 'Telugu', 'Tajik', 'Thai', 'Turkish', 'Uighur', 'Ukrainian', 'Urdu', 'Uzbek', 'Vietnamese', 'Xhosa', 'Yoruba', 'Chinese(traditional)', 'Chinese(simplified)', 'Zulu' ]

const chapters = [
  {
    id:1,
    arabicChapters: "Al-Faatiha",
    englishChapters: "The Opening",
    chaplength: 7,
  },
  {
    id:2,
    arabicChapters: "Al-Baqara",
    englishChapters: "The Cow",
    chaplength: 286,
  },
  {
    id:3,
    arabicChapters: "Aal-i-Imraan",
    englishChapters: "The Family of Imraan",
    chaplength: 200,
  },
  {
    id:4,
    arabicChapters: "An-Nisaa",
    englishChapters: "The Women",
    chaplength: 176,
  },
  {
    id:5,
    arabicChapters: "Al-Maaida",
    englishChapters: "The Table",
    chaplength: 120,
  },
  {
    id:6,
    arabicChapters: "Al-An'aam",
    englishChapters: "The Cattle",
    chaplength: 165,
  },
  {
    id:7,
    arabicChapters: "Al-A'raaf",
    englishChapters: "The Heights",
    chaplength: 206,
  },
  {
    id:8,
    arabicChapters: "Al-Anfaal",
    englishChapters: "The Spoils of War",
    chaplength: 75,
  },
  {
    id:9,
    arabicChapters: "At-Tawba",
    englishChapters: "The Repentance",
    chaplength: 129,
  },
  {
    id:10,
    arabicChapters: "Yunus",
    englishChapters: "Jonas",
    chaplength: 109,
  },
  {
    id:11,
    arabicChapters: "Hud",
    englishChapters: "Hud",
    chaplength: 123,
  },
  {
    id:12,
    arabicChapters: "Yusuf",
    englishChapters: "Joseph",
    chaplength: 111,
  },
  {
    id:13,
    arabicChapters: "Ar-Ra'd",
    englishChapters: "The Thunder",
    chaplength: 43,
  },
  {
    id:14,
    arabicChapters: "Ibrahim",
    englishChapters: "Abraham",
    chaplength: 52,
  },
  {
    id:15,
    arabicChapters: "Al-Hijr",
    englishChapters: "The Rock",
    chaplength: 99,
  },
  {
    id:16,
    arabicChapters: "An-Nahl",
    englishChapters: "The Bee",
    chaplength: 128,
  },
  {
    id:17,
    arabicChapters: "Al-Israa",
    englishChapters: "The Night Journey",
    chaplength: 111,
  },
  {
    id:18,
    arabicChapters: "Al-Kahf",
    englishChapters: "The Cave",
    chaplength: 110,
  },
  {
    id:19,
    arabicChapters: "Maryam",
    englishChapters: "Mary",
    chaplength: 98,
  },
  {
    id:20,
    arabicChapters: "Taa-Haa",
    englishChapters: "Taa-Haa",
    chaplength: 135,
  },
  {
    id:21,
    arabicChapters: "Al-Anbiyaa",
    englishChapters: "The Prophets",
    chaplength: 112,
  },
  {
    id:22,
    arabicChapters: "Al-Hajj",
    englishChapters: "The Pilgrimage",
    chaplength: 78,
  },
  {
    id:23,
    arabicChapters: "Al-Muminoon",
    englishChapters: "The Believers",
    chaplength: 118,
  },
  {
    id:24,
    arabicChapters: "An-Noor",
    englishChapters: "The Light",
    chaplength: 64,
  },
  {
    id:25,
    arabicChapters: "Al-Furqaan",
    englishChapters: "The Criterion",
    chaplength: 77,
  },
  {
    id:26,
    arabicChapters: "Ash-Shu'araa",
    englishChapters: "The Poets",
    chaplength: 227,
  },
  {
    id:27,
    arabicChapters: "An-Naml",
    englishChapters: "The Ant",
    chaplength: 93,
  },
  {
    id:28,
    arabicChapters: "Al-Qasas",
    englishChapters: "The Stories",
    chaplength: 88,
  },
  {
    id:29,
    arabicChapters: "Al-Ankaboot",
    englishChapters: "The Spider",
    chaplength: 69,
  },
  {
    id:30,
    arabicChapters: "Ar-Room",
    englishChapters: "The Romans",
    chaplength: 60,
  },
  {
    id:31,
    arabicChapters: "Luqman",
    englishChapters: "Luqman",
    chaplength: 34,
  },
  {
    id:32,
    arabicChapters: "As-Sajda",
    englishChapters: "The Prostration",
    chaplength: 30,
  },
  {
    id:33,
    arabicChapters: "Al-Ahzaab",
    englishChapters: "The Clans",
    chaplength: 73,
  },
  {
    id:34,
    arabicChapters: "Saba",
    englishChapters: "Sheba",
    chaplength: 54,
  },
  {
    id:35,
    arabicChapters: "Faatir",
    englishChapters: "The Originator",
    chaplength: 45,
  },
  {
    id:36,
    arabicChapters: "Yaseen",
    englishChapters: "Yaseen",
    chaplength: 83,
  },
  {
    id:37,
    arabicChapters: "As-Saaffaat",
    englishChapters: "Those drawn up in Ranks",
    chaplength: 182,
  },
  {
    id:38,
    arabicChapters: "Saad",
    englishChapters: "The letter Saad",
    chaplength: 88,
  },
  {
    id:39,
    arabicChapters: "Az-Zumar",
    englishChapters: "The Groups",
    chaplength: 75,
  },
  {
    id:40,
    arabicChapters: "Ghafir",
    englishChapters: "The Forgiver",
    chaplength: 85,
  },
  {
    id:41,
    arabicChapters: "Fussilat",
    englishChapters: "Explained in detail",
    chaplength: 54,
  },
  {
    id:42,
    arabicChapters: "Ash-Shura",
    englishChapters: "Consultation",
    chaplength: 53,
  },
  {
    id:43,
    arabicChapters: "Az-Zukhruf",
    englishChapters: "Ornaments of gold",
    chaplength: 89,
  },
  {
    id:44,
    arabicChapters: "Ad-Dukhaan",
    englishChapters: "The Smoke",
    chaplength: 59,
  },
  {
    id:45,
    arabicChapters: "Al-Jaathiya",
    englishChapters: "Crouching",
    chaplength: 37,
  },
  {
    id:46,
    arabicChapters: "Al-Ahqaf",
    englishChapters: "The Dunes",
    chaplength: 35,
  },
  {
    id:47,
    arabicChapters: "Muhammad",
    englishChapters: "Muhammad",
    chaplength: 38,
  },
  {
    id:48,
    arabicChapters: "Al-Fath",
    englishChapters: "The Victory",
    chaplength: 29,
  },
  {
    id:49,
    arabicChapters: "Al-Hujuraat",
    englishChapters: "The Inner Apartments",
    chaplength: 18,
  },
  {
    id:50,
    arabicChapters: "Qaaf",
    englishChapters: "The letter Qaaf",
    chaplength: 45,
  },
  {
    id:51,
    arabicChapters: "Adh-Dhaariyat",
    englishChapters: "The Winnowing Winds",
    chaplength: 60,
  },
  {
    id:52,
    arabicChapters: "At-Tur",
    englishChapters: "The Mount",
    chaplength: 49,
  },
  {
    id:53,
    arabicChapters: "An-Najm",
    englishChapters: "The Star",
    chaplength: 62,
  },
  {
    id:54,
    arabicChapters: "Al-Qamar",
    englishChapters: "The Moon",
    chaplength: 55,
  },
  {
    id:55,
    arabicChapters: "Ar-Rahmaan",
    englishChapters: "The Beneficent",
    chaplength: 78,
  },
  {
    id:56,
    arabicChapters: "Al-Waaqia",
    englishChapters: "The Inevitable",
    chaplength: 96,
  },
  {
    id:57,
    arabicChapters: "Al-Hadid",
    englishChapters: "The Iron",
    chaplength: 29,
  },
  {
    id:58,
    arabicChapters: "Al-Mujaadila",
    englishChapters: "The Pleading Woman",
    chaplength: 22,
  },
  {
    id:59,
    arabicChapters: "Al-Hashr",
    englishChapters: "The Exile",
    chaplength: 24,
  },
  {
    id:60,
    arabicChapters: "Al-Mumtahana",
    englishChapters: "She that is to be examined",
    chaplength: 13,
  },
  {
    id:61,
    arabicChapters: "As-Saff",
    englishChapters: "The Ranks",
    chaplength: 14,
  },
  {
    id:62,
    arabicChapters: "Al-Jumu'a",
    englishChapters: "Friday",
    chaplength: 11,
  },
  {
    id:63,
    arabicChapters: "Al-Munaafiqoon",
    englishChapters: "The Hypocrites",
    chaplength: 11,
  },
  {
    id:64,
    arabicChapters: "At-Taghaabun",
    englishChapters: "Mutual Disillusion",
    chaplength: 18,
  },
  {
    id:65,
    arabicChapters: "At-Talaaq",
    englishChapters: "Divorce",
    chaplength: 12,
  },
  {
    id:66,
    arabicChapters: "At-Tahrim",
    englishChapters: "The Prohibition",
    chaplength: 12,
  },
  {
    id:67,
    arabicChapters: "Al-Mulk",
    englishChapters: "The Sovereignty",
    chaplength: 30,
  },
  {
    id:68,
    arabicChapters: "Al-Qalam",
    englishChapters: "The Pen",
    chaplength: 52,
  },
  {
    id:69,
    arabicChapters: "Al-Haaqqa",
    englishChapters: "The Reality",
    chaplength: 52,
  },
  {
    id:70,
    arabicChapters: "Al-Ma'aarij",
    englishChapters: "The Ascending Stairways",
    chaplength: 44,
  },
  {
    id:71,
    arabicChapters: "Nooh",
    englishChapters: "Noah",
    chaplength: 28,
  },
  {
    id:72,
    arabicChapters: "Al-Jinn",
    englishChapters: "The Jinn",
    chaplength: 28,
  },
  {
    id:73,
    arabicChapters: "Al-Muzzammil",
    englishChapters: "The Enshrouded One",
    chaplength: 20,
  },
  {
    id:74,
    arabicChapters: "Al-Muddaththir",
    englishChapters: "The Cloaked One",
    chaplength: 56,
  },
  {
    id:75,
    arabicChapters: "Al-Qiyaama",
    englishChapters: "The Resurrection",
    chaplength: 40,
  },
  {
    id:76,
    arabicChapters: "Al-Insaan",
    englishChapters: "Man",
    chaplength: 31,
  },
  {
    id:77,
    arabicChapters: "Al-Mursalaat",
    englishChapters: "The Emissaries",
    chaplength: 50,
  },
  {
    id:78,
    arabicChapters: "An-Naba",
    englishChapters: "The Announcement",
    chaplength: 40,
  },
  {
    id:79,
    arabicChapters: "An-Naazi'aat",
    englishChapters: "Those who drag forth",
    chaplength: 46,
  },
  {
    id:80,
    arabicChapters: "Abasa",
    englishChapters: "He frowned",
    chaplength: 42,
  },
  {
    id:81,
    arabicChapters: "At-Takwir",
    englishChapters: "The Overthrowing",
    chaplength: 29,
  },
  {
    id:82,
    arabicChapters: "Al-Infitaar",
    englishChapters: "The Cleaving",
    chaplength: 19,
  },
  {
    id:83,
    arabicChapters: "Al-Mutaffifin",
    englishChapters: "Defrauding",
    chaplength: 36,
  },
  {
    id:84,
    arabicChapters: "Al-Inshiqaaq",
    englishChapters: "The Splitting Open",
    chaplength: 25,
  },
  {
    id:85,
    arabicChapters: "Al-Burooj",
    englishChapters: "The Constellations",
    chaplength: 22,
  },
  {
    id:86,
    arabicChapters: "At-Taariq",
    englishChapters: "The Morning Star",
    chaplength: 17,
  },
  {
    id:87,
    arabicChapters: "Al-A'laa",
    englishChapters: "The Most High",
    chaplength: 19,
  },
  {
    id:88,
    arabicChapters: "Al-Ghaashiya",
    englishChapters: "The Overwhelming",
    chaplength: 26,
  },
  {
    id:89,
    arabicChapters: "Al-Fajr",
    englishChapters: "The Dawn",
    chaplength: 30,
  },
  {
    id:90,
    arabicChapters: "Al-Balad",
    englishChapters: "The City",
    chaplength: 20,
  },
  {
    id:91,
    arabicChapters: "Ash-Shams",
    englishChapters: "The Sun",
    chaplength: 15,
  },
  {
    id:92,
    arabicChapters: "Al-Lail",
    englishChapters: "The Night",
    chaplength: 21,
  },
  {
    id:93,
    arabicChapters: "Ad-Dhuhaa",
    englishChapters: "The Morning Hours",
    chaplength: 11,
  },
  {
    id:94,
    arabicChapters: "Ash-Sharh",
    englishChapters: "The Consolation",
    chaplength: 8,
  },
  {
    id:95,
    arabicChapters: "At-Tin",
    englishChapters: "The Fig",
    chaplength: 8,
  },
  {
    id:96,
    arabicChapters: "Al-Alaq",
    englishChapters: "The Clot",
    chaplength: 19,
  },
  {
    id:97,
    arabicChapters: "Al-Qadr",
    englishChapters: "The Power, Fate",
    chaplength: 5,
  },
  {
    id:98,
    arabicChapters: "Al-Bayyina",
    englishChapters: "The Evidence",
    chaplength: 8,
  },
  {
    id:99,
    arabicChapters: "Az-Zalzala",
    englishChapters: "The Earthquake",
    chaplength: 8,
  },
  {
    id:100,
    arabicChapters: "Al-Aadiyaat",
    englishChapters: "The Chargers",
    chaplength: 11,
  },
  {
    id:101,
    arabicChapters: "Al-Qaari'a",
    englishChapters: "The Calamity",
    chaplength: 11,
  },
  {
    id:102,
    arabicChapters: "At-Takaathur",
    englishChapters: "Competition",
    chaplength: 8,
  },
  {
    id:103,
    arabicChapters: "Al-Asr",
    englishChapters: "The Declining Day, Epoch",
    chaplength: 3,
  },
  {
    id:104,
    arabicChapters: "Al-Humaza",
    englishChapters: "The Traducer",
    chaplength: 9,
  },
  {
    id:105,
    arabicChapters: "Al-Fil",
    englishChapters: "The Elephant",
    chaplength: 5,
  },
  {
    id:106,
    arabicChapters: "Quraish",
    englishChapters: "Quraysh",
    chaplength: 4,
  },
  {
    id:107,
    arabicChapters: "Al-Maa'un",
    englishChapters: "Almsgiving",
    chaplength: 7,
  },
  {
    id:108,
    arabicChapters: "Al-Kawthar",
    englishChapters: "Abundance",
    chaplength: 3,
  },
  {
    id:109,
    arabicChapters: "Al-Kaafiroon",
    englishChapters: "The Disbelievers",
    chaplength: 6,
  },
  {
    id:110,
    arabicChapters: "An-Nasr",
    englishChapters: "Divine Support",
    chaplength: 3,
  },
  {
    id:111,
    arabicChapters: "Al-Masad",
    englishChapters: "The Palm Fibre",
    chaplength: 5,
  },
  {
    id:112,
    arabicChapters: "Al-Ikhlaas",
    englishChapters: "Sincerity",
    chaplength: 4,
  },
  {
    id:113,
    arabicChapters: "Al-Falaq",
    englishChapters: "The Dawn",
    chaplength: 5,
  },
  {
    id:113,
    arabicChapters: "An-Naas",
    englishChapters: "Mankind",
    chaplength: 6,
  },
];

const fatha = [
  {
      "chapter": 1,
      "verse": 1,
      "text": "surat alfatihat sumiyat hadhih alswrt balfatht; li'anah yaftatih biha alquran alezym, wtsma almthany; li'anaha taqra fi kl rket, walaha 'asma' akhr. 'abtadi qra't alquran biaism allah msteyna bh, (allhi) eilm ealaa alrb -tbark wteala- almebwd bihaqi dun swah, wahu akhs 'asma' allah teala, wala yusamaa bih ghyrh sbhanh. (alrrahmani) dhi alrahmat aleamat aldhy wasieat rahmatih jmye alkhlq, (alrrahimi) balmwmnyn, wahuma aisman min 'asmayih teala, ytdmnan 'iithbat sifat alrahmat lilah taealaa kama ylyq bjlalh"
  },
  {
      "chapter": 1,
      "verse": 2,
      "text": "(alhamd llh rabb alealamina) althna' ealaa allah bsfath alty klluha awsaf kmal, wbnemh alzzahirat walbatnt, aldiyniat waldnywyt, wafi dmnh 'amr lieibadih 'ana yhmdwh, fahu almsthq lah whdh, wahu subhanah almnshy llkhlq, alqayim bamwrhm, almrby lajamie khalaqah bnemh, wlawlyayh bial'iiman waleamal alsalh"
  },
  {
      "chapter": 1,
      "verse": 3,
      "text": "(alrrahmani) aldhy wasieat rahmatih jmye alkhlq, (alrrahimi), balmwmnyn, wahuma aisman min 'asma' allah teala"
  },
  {
      "chapter": 1,
      "verse": 4,
      "text": "whw subhanah wahdah malik yawm alqyamt, wahu yawm aljaza' ealaa alaemal. wafi qra't almuslim lihadhih alayat fi kl rket min slwath tadhkir lah bialyawm alakhr, whthth lah ealaa alaistiedad bialeamal alsalh, walkf ean almeasy walsyyat"
  },
  {
      "chapter": 1,
      "verse": 5,
      "text": "'ina nkhsk whdk balebadt, wnsteyn bik whdk fi jmye amwrna, falamr klh bydk, la yamlik minh ahd mithqal dhr. wafi hadhih alayat dalil ealaa 'ana aleabd la yajuz lah 'an yusraf shyyana min 'anwae alebadt kaldea' walastghatht waldhbh waltwaf 'iilaa lilah whdh, wafiha shifa' alqulub min da' altelq bighayr allh, wamin 'amrad alrya' walejb, walkbrya'"
  },
  {
      "chapter": 1,
      "verse": 6,
      "text": "dullana, warshdna, wwfqna 'iilaa altariq almstqym, wthbtna ealayh hataa nlqak, wahu al'islam, aldhy hu altariq alwadih almawsil 'iilaa ridwan allah wa'iilaa jnth, aldhy dl ealayh khatm rusulah wanbyayh muhamad salaa allah ealayh wslm, fala sabil 'iilaa saeadat aleabd 'iilaa balastqamt elyh"
  },
  {
      "chapter": 1,
      "verse": 7,
      "text": "tryq aladhin 'aneamt ealayhim min alnabiiyn walsddiqyn walshuhada' walsalhyn, fahum 'ahl alhdayt walastqamt, wala tajealna mmn silk tariq almaghdub elyhm, aladhin earafuu alhaqu walam yaemaluu bh, wahum alyhwd, waman kan ealaa shaklthm, waldalyn, wahum aldhyn lm yhtdu, fadaluu altryq, wahum alnsara, wamin atabae snthm. wafi hdha alduea' shifa' liqalb almuslim min marad aljhwd waljhl waldlal, wdlalt ealaa 'an 'aezam niemat ealaa al'iitlaq hi niemat al'islam, faman kan 'aerif lilhaqi watbe lh, kan 'uwlaa balsrat almstqym, wala rayb 'ana 'ashab rasul allah salaa allah ealayh wasalam hum 'awlaa alnaas bdhlk baed al'anbia' ealayhim alslam, fdlt alayat ealaa fdlhm, wezym mnzlthm, radi allah eanhum. wysthb llqary 'an yaqul fi alsalat baed qra't alfatht: (amyn), wmenaha: allahuma astjb, walaysat ayatan min surat alfatihat batfaq alelma'; wlhdha 'ajmaeuu ealaa edm ktabtha fi almsahf"
  }
]
export { languages, chapters, fatha };
